import type { NotificationColorScheme } from '@parlay-picker/shared/notificationDisplay';

export const COLOR_SCHEME_CLASSES: Record<
  NotificationColorScheme,
  {
    stripe: string;
    badgeBg: string;
    badgeText: string;
    iconBg: string;
    iconText: string;
  }
> = {
  success: {
    stripe: '#22c55e',
    badgeBg: 'bg-theme-success/15',
    badgeText: 'text-theme-success',
    iconBg: 'bg-theme-success/15',
    iconText: 'text-theme-success',
  },
  danger: {
    stripe: '#ef4444',
    badgeBg: 'bg-theme-danger/15',
    badgeText: 'text-theme-danger',
    iconBg: 'bg-theme-danger/15',
    iconText: 'text-theme-danger',
  },
  warning: {
    stripe: '#f59e0b',
    badgeBg: 'bg-yellow-400/15',
    badgeText: 'text-yellow-400',
    iconBg: 'bg-yellow-400/15',
    iconText: 'text-yellow-400',
  },
  primary: {
    stripe: '#3b82f6',
    badgeBg: 'bg-theme-primary/15',
    badgeText: 'text-theme-primary',
    iconBg: 'bg-theme-primary/15',
    iconText: 'text-theme-primary',
  },
  muted: {
    stripe: '#6b7280',
    badgeBg: 'bg-theme-surface-hover/50',
    badgeText: 'text-theme-text-tertiary',
    iconBg: 'bg-theme-surface-hover/50',
    iconText: 'text-theme-text-tertiary',
  },
};
